<template>
<div v-if="item" class="card bg-white overflow-hidden">
    <div class="card-body">
        <div class="">
            <div class="profile-user position-relative d-inline-block mx-auto mb-4">
                <img @click="showProfileImg(item.image)" :src="absoluteUrl(item.image)"
                class="rounded-circle avatar-xl img-thumbnail
                    user-profile-image cursor-pointer" alt="user-profile-image" />
            </div>
            <p class="mb-2"> <span class="text-muted">Created by</span></p>
            <h5 class="fs-16 mb-1">
                {{item.first_name}} {{item.last_name}}
            </h5>
            <p class="mb-0 text-muted">{{ item.email }}</p>
        </div>
    </div>
    <div class="circles-container" ><div class="circle-back" ></div><div class="circle-front" ></div></div>
</div>
</template>


<script>
export default {
    props:{
        item:{
            type:Object,
            required: true
        }
    }, 
}
</script>

<style  scoped>
.circles-container {
    position: absolute;
    bottom: 0;
    top:0;
    width: 20%;
    right: -20%;
}

.circle-back, .circle-front{
    background-color: #e1f6e2;
    position: relative;
    width: 200%;
    padding-top: 200%;
    padding-bottom: 0;
    border-radius: 100%;
    display: inline-block
}
.circle-back {
    opacity: .6;
    z-index: 3;
    margin-left: -108%;
    margin-top: 0
}

.circle-front {
    opacity: .5;
    margin-bottom: 50%;
    margin-left: -209%;
    z-index: 4
}
</style>